import { render, staticRenderFns } from "./StudentOpenPdf.vue?vue&type=template&id=0825cc3e&scoped=true&lang=pug&"
import script from "./StudentOpenPdf.vue?vue&type=script&lang=ts&"
export * from "./StudentOpenPdf.vue?vue&type=script&lang=ts&"
import style0 from "./StudentOpenPdf.vue?vue&type=style&index=0&id=0825cc3e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0825cc3e",
  null
  
)

export default component.exports